import React from 'react';
import {
  Alert,
  AlertIcon,
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from '@chakra-ui/react';
import {useDeleteIntentSource} from '../../hooks/api/intent';
import {WebIntentSource} from '../../shared/intent';

export const DeleteWebIntentSourceModal = ({
  isOpen,
  onClose,
  intentSource,
}: {
  isOpen: boolean;
  onClose: () => void;
  intentSource: WebIntentSource;
}) => {
  const toast = useToast();
  const deleteSource = useDeleteIntentSource();

  return (
    <Modal isCentered={true} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontWeight="normal" pb="1" pt="6">
          Delete Source
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody px="6" pt="6" pb="8" color="kgray.300">
          <Text>
            Are you sure you want to delete{' '}
            <strong>{intentSource.label}</strong>? This action can&#39;t be
            undone.
          </Text>
          <Alert status="warning" mt="4" borderRadius="md">
            <AlertIcon />
            All historical intent data associated with this source will also be
            deleted.
          </Alert>
        </ModalBody>
        <Divider />
        <ModalFooter justifyContent="start" gap="4">
          <Button
            colorScheme="red"
            isLoading={deleteSource.isPending}
            onClick={() => {
              deleteSource.mutate(
                {sourceId: intentSource.id},
                {
                  onSuccess: () => {
                    toast({
                      status: 'success',
                      title: 'Source deleted.',
                      duration: 2_000,
                      isClosable: true,
                    });
                    onClose();
                  },
                }
              );
            }}
          >
            Delete
          </Button>
          <Button color="kgray.300" onClick={onClose} variant="ghost">
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
